module.exports = __webpack_public_path__ + "media/steps/raport_icon@3x-150294bc.png";